import Store from 'store/store';
import { debounce } from 'utils/utils';
import { getDynamicData, transformPageData } from 'utils/bolt/dynamicData';

const allTiles = [];

const getDataFromCarousels = (carousels) => {
	Object.values(carousels).forEach((carousel) => {
		Object.values(carousel.tiles).forEach((tile) => {
			const tileCopy = { ...tile };
			if (carousel.tag) {
				tileCopy.carouselTag = carousel.tag;
			}
			allTiles.push(tileCopy);
		});
	});
};

const getAllTiles = async () => {
	let dynamicFilmPages = await getDynamicData('film-pages');
	Object.values(dynamicFilmPages).forEach(dynamicPage => transformPageData(dynamicPage, dynamicPage.url));
	const store = Store.get();
	const pages = store?.appData?.pages || {};
	const carousels = pages.landingPage?.data?.carousels || {};
	getDataFromCarousels(carousels);
	const libraryCarousels = pages.library?.data?.carousels || {};
	getDataFromCarousels(libraryCarousels);

	// only search the film pages set via CMS
	const filmPages = Object.values(pages).filter(page => page.type === 'filmPage' && page.customPageComponent === 'film');
	if (filmPages?.length > 0) {
		filmPages.forEach((page) => {
			const heroData = page.data?.find(e => e.id === 'filmHero')?.data || {};
			const synopsisData = page.data?.find(e => e.id === 'filmSynopsis')?.data || {};
			const allSynopsisContent = getSynopsisContent(synopsisData);
			const duplicateTileIndex = allTiles.findIndex(tile => tile.title?.toLowerCase().trim() === heroData.title?.toLowerCase().trim());
			if (duplicateTileIndex > -1) {
				allTiles.splice(duplicateTileIndex, 1);
			}
			const tile = {
				title: heroData.title,
				teaser: heroData.description,
				asset: heroData.background?.desktop,
				tag: heroData.tag,
				keywords: heroData.keywords,
				synopsisContent: allSynopsisContent,
				buttons: {},
				filmPage: true
			};
			const heroButtons = Object.keys(heroData.buttons || {});
			if (heroButtons.length) {
				heroButtons.forEach((key) => {
					tile.buttons[key] = {
						...heroData.buttons[key],
						btnCopy: heroData.buttons[key].label,
						link: `${heroData.buttons[key].link?.startsWith('#') ? page.id : ''}${heroData.buttons[key].link}`
					};
				});
			}
			allTiles.push(tile);
		});
	}
};

const isTermMatched = (text, term) => {
	if (!text || !term) return false;
	return text.toLowerCase().includes(term) || replaceAccentedChars(text.toLowerCase()).includes(term);
};

const findMatches = async (val) => {
	if (allTiles.length < 1) {
		await getAllTiles();
	}
	const results = !val ? [] : allTiles.filter((tile) => {
		const searchTerms = val.split(/[\s,]+/).filter(a => a).map(a => a.toLowerCase().replaceAll(/[.,]/g, ''));
		let includeInResult = true;
		searchTerms.forEach(term => {
			if (
				!isTermMatched(tile.title, term) &&
				!isTermMatched(tile.teaser, term) &&
				!isTermMatched(tile.keywords, term) &&
				!isTermMatched(tile.tag, term) &&
				!isTermMatched(tile.carouselTag, term) &&
				!isTermMatched(tile.synopsisContent, term)
			) {
				includeInResult = false;
			}
		});
		return includeInResult;
	});
	
	const uniqueResults = [];

	results.map(res => {
		const duplicateIndex = uniqueResults.findIndex(result => result.title === res.title);
		if (duplicateIndex !== -1) {
			return res.filmPage && uniqueResults.splice(duplicateIndex, 1, res);
		}
		uniqueResults.push(res);
	});

	Store.get().search.set({
		results: uniqueResults,
		searchedTerm: val
	});
};

const findMatchesDebounced = debounce(findMatches);

const getSynopsisContent = (data) => {
	let content = `${data.tagline || ''}${data.tagline ? ' ' : ''}${data.content || ''}${data.content ? ' ' : ''}`;
	const credits = data.credits || {};
	if (Object.values(credits).length > 0) {
		Object.values(credits).forEach((credit) => {
			if (credit.names) {
				content += `${credit.names} `;
			}
		});
	}
	return content;
};

const replaceAccentedChars = (str) => {
	return str.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
};

Store.on('UPDATE_SEARCH_INPUT', (val) => {
	Store.get().search.set({
		searchInput: val
	});
	findMatchesDebounced(val);
});

Store.on('LAST_PAGE_BEFORE_SEARCH', (page) => {
	Store.get().search.set({
		lastPageBeforeSearch: page
	});
});

Store.on('TOGGLE_SEARCH_FIELD', (bool) => {
	Store.get().search.set({
		showSearchField: bool
	});
});